import { render } from "./employee_customer.vue?vue&type=template&id=f8ef59dc&scoped=true"
import script from "./employee_customer.vue?vue&type=script&lang=js"
export * from "./employee_customer.vue?vue&type=script&lang=js"

import "./employee_customer.vue?vue&type=style&index=0&id=f8ef59dc&scoped=true&lang=css"

import exportComponent from "D:\\learning\\isp_digital\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8ef59dc"]])

export default __exports__